// extracted by mini-css-extract-plugin
module.exports = {"goup":"style_goup__1n5Nu","hidden":"style_hidden__2h8b-","arrow":"style_arrow__2fOFD","nahoru":"style_nahoru__29nff"};